import { DatePickerCalendarAlternateIcon } from "./DatePickerCalendarAlternateIcon";

/** Default MUI X DatePicker slots — Figma `Calendar-Alternate` open-picker icon. */
export const appDatePickerSlots = {
  openPickerIcon: DatePickerCalendarAlternateIcon,
} as const;
